<template lang="pug">
#social_responsibility
  .container.custom_container_lg
    .row
      breadcrumb
  .container.custom_container_lg.i_mt_14.i_mt_md_10.text-center
    .desc
      p {{ CSR.area01_Content }}
    .row.i_mt_8(v-if="!isExpand")
      .collapse_btn(@click="expand") 查看永續發展政策

  .container-fluid.detail.bg_blue.i_mt_6(ref="detail")
    .container.i_ptb_8
      .row
        .col-12
          .desc.detail
            p(v-html="CSR.area01_ContentDetail")
      .row.i_mt_8(v-if="isExpand")
        .collapse_btn(@click="expand", :class="{ expand: isExpand }") 收起永續發展政策

  section.container.download.i_pt_18.d-flex.flex-column.justify-content-center
    .row.i_mb_10.i_mb_md_6
      .col-12.text-center
        h2.title 永續報告書下載
    .row.flex-wrap.year_items(
      v-for="(fileRow, rowIndex) in Math.ceil(CSR.area02_FileList.length / 5)"
    )
      .col-auto(
        v-for="(file, index) in CSR.area02_FileList",
        v-if="index < (rowIndex + 1) * 5 && index >= rowIndex * 5"
      )
        a.year_item.d-flex.align-items-center.i_mb_4(
          :href="file.area02_FileURL"
        )
          svg-icon(iconClass="ic_download", className="icon")
          p.i_body_l.i_ml_2.i_pr_1 {{ file.area02_Title }}

    .img.i_mt_4(
      v-if="CSR && $store.state.screenWidth > 991",
      :style="{ backgroundImage: 'url(' + CSR.area02_BannerPC + ')' }"
    )

    .img.i_mt_4(
      v-if="CSR && $store.state.screenWidth <= 991",
      :style="{ backgroundImage: 'url(' + CSR.area02_BannerMobile + ')' }"
    )

  section.container.items.i_pt_18
    .row.i_mb_10.i_mb_md_8
      .col-12.text-center
        h2.title {{ CSR.area03_Title }}
    .row
      .col-md-6.i_mb_9.i_mb_md_7.i_mb_sm_8(
        v-for="(item, index) in itemList",
        :key="index"
      )
        item(:item="item")
</template>

<script>
import Velocity from "velocity-animate";
import MediaImg from "@/components/common/MediaImg";
import Item from "@/components/about_us/social_responsibility/Item";
import { getCSR } from "@/json/about_us";
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "Governance",
  metaInfo() {
    return {
      title: this.CSR.SEO_Title,
      meta: [{ name: "description", content: this.CSR.SEO_Description }],
    };
  },
  components: {
    "media-img": MediaImg,
    item: Item,
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      CSR: {
        area02_FileList: [],
      },
      isExpand: false,
      itemList: [],
    };
  },
  mounted() {
    this.onResize();
  },
  created() {
    this.getCSR();
  },
  methods: {
    onResize() {
      var thiz = this;

      window.onresize = function () {
        // 定義視窗大小變更通知事件
        thiz.$store.state.screenWidth = document.documentElement.clientWidth; //視窗寬度
        thiz.$store.state.screenHeight = document.documentElement.clientHeight; //視窗高度
      };
    },
    expand() {
      this.isExpand = !this.isExpand;

      if (this.isExpand) {
        //取得元素完整高度
        var height = this.$refs.detail.scrollHeight + 50;

        Velocity(
          this.$refs.detail,
          { maxHeight: height, opacity: 1 },
          { duration: 300 }
        );
      } else {
        Velocity(
          this.$refs.detail,
          { maxHeight: 0, opacity: 0 },
          { duration: 300 }
        );
      }
    },
    getCSR() {
      getCSR().then((response) => {
        this.CSR = response.data;
        this.itemList = [];

        let tempItem1 = {
          title: this.CSR.area03_SubTitle01,
          content: this.CSR.area03_Content01,
          img: this.CSR.area03_Icon01,
          pageUrl: this.CSR.area03_PageUrl01,
        };
        this.itemList.push(tempItem1);
        let tempItem2 = {
          title: this.CSR.area03_SubTitle02,
          content: this.CSR.area03_Content02,
          img: this.CSR.area03_Icon02,
          pageUrl: this.CSR.area03_PageUrl02,
        };
        this.itemList.push(tempItem2);
        let tempItem3 = {
          title: this.CSR.area03_SubTitle03,
          content: this.CSR.area03_Content03,
          img: this.CSR.area03_Icon03,
          pageUrl: this.CSR.area03_PageUrl03,
        };
        this.itemList.push(tempItem3);
        let tempItem4 = {
          title: this.CSR.area03_SubTitle04,
          content: this.CSR.area03_Content04,
          img: this.CSR.area03_Icon04,
          pageUrl: this.CSR.area03_PageUrl04,
        };
        this.itemList.push(tempItem4);
        let tempItem5 = {
          title: this.CSR.area03_SubTitle05,
          content: this.CSR.area03_Content05,
          img: this.CSR.area03_Icon05,
          pageUrl: this.CSR.area03_PageUrl05,
        };
        this.itemList.push(tempItem5);
        let tempItem6 = {
          title: this.CSR.area03_SubTitle06,
          content: this.CSR.area03_Content06,
          img: this.CSR.area03_Icon06,
          pageUrl: this.CSR.area03_PageUrl06,
        };
        this.itemList.push(tempItem6);
      });
    },
  },
  watch: {
    "$store.state.screenWidth": function () {
      if (this.isExpand) {
        //取得元素完整高度
        var height = this.$refs.detail.scrollHeight + 20;

        Velocity(
          this.$refs.detail,
          { maxHeight: height, opacity: 1 },
          { duration: 0 }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/about_us";
@import "@/assets/style/about_us/social_responsibility";
</style>
